<template>
  <APPDetails :isMember="true" :userInformation="userInformation"/>
</template>

<script>
import APPDetails from '@/components/pages/InformationPortal/APPDetails/APPDetails.vue'

export default{
    name: 'Members',
    props: {
      userInformation: {
            type: Object,
            default: () => {}
        }
    },
    components:{
        APPDetails
    }
}
</script>